import { render, staticRenderFns } from "./dealDetailListComponent.vue?vue&type=template&id=1c977fb2&scoped=true&"
import script from "./dealDetailListComponent.vue?vue&type=script&lang=js&"
export * from "./dealDetailListComponent.vue?vue&type=script&lang=js&"
import style0 from "./dealDetailListComponent.vue?vue&type=style&index=0&id=1c977fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c977fb2",
  null
  
)

export default component.exports